import { EntityLocation, EntityLocationsApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export abstract class EntityLocationService {
	private static entityLocationApi = new EntityLocationsApi();

	public static async handleEntityLocation(
		entityLocation: EntityLocation,
		existingLocation: EntityLocation | null,
	): Promise<{ errorMessage: string } | void> {
		try {
			if (this.entityLocationSet(entityLocation)) {
				if (!existingLocation?.id) {
					await this.entityLocationApi.createEntityLocation({ data: entityLocation });
				} else {
					await this.entityLocationApi.updateEntityLocation(existingLocation.id, {
						data: entityLocation,
					});
				}
			}
		} catch (e) {
			return ApiUtils.handleApiError(e, 'Failed to update entity location');
		}
	}

	public static async updateEntityLocation(
		entityLocationId: number,
		entityLocation: EntityLocation,
	): Promise<void> {
		await this.entityLocationApi.updateEntityLocation(entityLocationId, { data: entityLocation });
	}

	private static entityLocationSet(entityLocation: EntityLocation): boolean {
		return !!(
			entityLocation.latitude &&
			entityLocation.latitude &&
			entityLocation.entityType &&
			entityLocation.entityId
		);
	}
}
